/* eslint-disable react/prop-types */
import {
  Row,
  Spin,
} from 'antd';
import { getHistoricosDeSindicato } from 'api/catalogos/historicoDeSindicatos';
import { checkToken } from 'api/utils';
import Table from 'components/Table';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { formatReceived } from 'utils/formatValues';
import { getModelPermission } from 'utils/permission';

export const historicoDeSindicatoPermission = {
  permissionModel: 'historicodesindicato',
  catalogsModels: [],
  tabsModels: [],
};

const ExpedienteSindicatos = ({
  currentEmpleado,
}) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const getPermission = getModelPermission(
    historicoDeSindicatoPermission.permissionModel,
    historicoDeSindicatoPermission.catalogsModels,
    historicoDeSindicatoPermission.tabsModels,
    false,
  );

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const response = await getHistoricosDeSindicato({ empleado: currentEmpleado });
      if (mounted) {
        const list = response?.results || response || [];
        setData(formatReceived(list));
        setLoading(false);
      }
    };
    if (currentEmpleado) {
      fetchAll();
    } else {
      setData([]);
      setLoading(false);
    }
    return () => { mounted = false; };
  }, [currentEmpleado]);

  const columns = [
    {
      titleText: 'Sindicato',
      dataIndex: 'sindicato',
      key: 'sindicato',
      width: 300,
      render: (val) => (val?.clave ? `${val.clave} ${val.descripcion}` : val?.descripcion),
    },
    {
      titleText: 'Fecha Inicial',
      dataIndex: 'fecha_inicial',
      key: 'fecha_inicial',
      width: 150,
      render: (val) => (val ? moment(val).format('DD/MM/YYYY') : ''),
    },
    {
      titleText: 'Fecha Final',
      dataIndex: 'fecha_final',
      key: 'fecha_final',
      width: 150,
      render: (val) => (val ? moment(val).format('DD/MM/YYYY') : ''),
    },
    {
      titleText: 'Solicitud',
      dataIndex: 'solicitud',
      key: 'solicitud',
      width: 250,
    },
    {
      titleText: 'Estatus',
      dataIndex: 'estatus',
      key: 'estatus',
      width: 120,
      render: (val) => (val ? 'Activo' : 'Inactivo'),
    },
  ];

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Table
          cols={columns}
          data={data}
          permission={getPermission}
          loading={loading}
        />
      </Spin>
    </Row>
  );
};

export default ExpedienteSindicatos;
